import { ref } from 'vue';

export default function useOfferCountDown() {
  const days = ref(0);
  const hours = ref(0);
  const minutes = ref(0);
  const seconds = ref(0);
  const getDifference = ref();
  const actualDate = ref();

  function start(targetDate, dateNow) {
    actualDate.value = dateNow;
    const interval = setInterval(() => {
      const difference = targetDate - actualDate.value;
      getDifference.value = difference;

      if (difference > 0) {
        actualDate.value = actualDate.value + 1000;
        days.value = Math.floor(difference / (1000 * 60 * 60 * 24));
        hours.value = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        minutes.value = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        seconds.value = Math.floor((difference % (1000 * 60)) / 1000);
      } else {
        clearInterval(interval);
      }
    }, 1000);
  }

  return {
    days,
    hours,
    minutes,
    seconds,
    getDifference,
    start,
  };
}
